<template>
    <m-main-layout>
        <base-button slot="right-btn" @click.native="$router.push({path:'/user/vip/list/'})" rule="/user/vip/list">查看等级列表</base-button>
        <add-button slot="right-btn" label="添加" v-if="dataList.length > 0" @click.native="$router.push({path:'/user/vip/price/add',query:{vip_id:vip_id}})" rule="/user/vip/price/add"></add-button>
        <div class="page-content-main">
            <el-table :data="dataList" default-expand-all style="width: 100%" :row-key="(row)=>{return row.is_spec && row.is_spec === 1 ? 'cell_'+row.id : 'sub_'+row.id}" :tree-props="{children: 'child'}" :indent="30" v-if="dataList.length > 0">
                <el-table-column
                        prop="title"
                        label="标题">
                </el-table-column>
                <el-table-column
                        label="价格">
                    <template slot-scope="scope">
                        {{scope.row.price}} / {{scope.row.to_time}}{{scope.row.time_type === 'day' ? '天' : scope.row.time_type === 'week' ? '周' : scope.row.time_type === 'month' ? '月' : '年'}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="sort"
                        label="排序">
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态" style="font-size:12px;">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.state === 1 ? 'success' : 'danger'" disable-transitions>{{scope.row.state === 0 ? '禁用' : '可用'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="create_time"
                        label="创建时间">
                    <template slot-scope="scope">
                        {{scope.row.create_time === 0 ? '—' : $moment.unix(scope.row.create_time).format('YYYY-M-D HH:mm:ss')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="update_time"
                        label="修改时间">
                    <template slot-scope="scope">
                        {{scope.row.update_time === 0 ? '—' : $moment.unix(scope.row.update_time).format('YYYY-M-D HH:mm:ss')}}
                    </template>
                </el-table-column>
                <el-table-column align="right" width="300">
                    <template slot-scope="scope">
                        <edit-button @click.native="$router.push({path:'/user/vip/price/edit/'+scope.row.id})" rule="/user/vip/price/edit"></edit-button>
                        <del-button @click.native="del(scope.row.id)" rule="/user/vip/price/del"></del-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="text-center null-data f14 info" v-else>
                还没有数据，<add-button slot="right-btn" @click.native="$router.push({path:'/user/vip/price/add',query:{vip_id:vip_id}})" rule="/user/vip/price/add" label="立即添加"></add-button>
            </div>
            <div class="text-center padding-top-bottom-20" v-if="dataList.length > 0">
                <el-pagination
                        background
                        layout="total,prev, pager, next"
                        :page-size="pageSize"
                        :current-page.sync="page"
                        :total="totalCount"
                        @current-change="pageChange">
                </el-pagination>
            </div>
        </div>
    </m-main-layout>
</template>

<script>
    export default {
        name: "GoodsSpecList",
        data(){
            return{
                dataList: [],
                totalPage:0,
                totalCount:0,
	            pageSize:20,
                page:1,
	            vip_id:''
            }
        },
        created(){
	        this.vip_id = this.$route.query.vip_id ? this.$route.query.vip_id : 0;
        },
        methods:{
            getList(){
                let _this = this;
                this.dataList = [];
                this.$http.httpPost({
                    url:'VipPrice/listPage',
                    datas:{vip_id:this.vip_id,page:this.page,pageSize:this.pageSize,orderBy:'sort',sortBy:'asc'},
                    success:(res)=>{
	                    _this.dataList = res.list;
                        _this.totalPage = res.totalPage;
                        _this.totalCount = res.totalCount;
                    }
                });
            },
	        del(id) {
		        let _this = this;
		        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
		        }).then(() => {
			        this.$http.httpPost({
				        url:'VipPrice/del',
				        datas:{id:id},
				        success:(res)=>{
					        _this.getList();
				        }
			        });
		        }).catch(() => {
		        });
	        },
	        pageChange(page){
		        this.page = page;
		        this.getList();
	        },
        },
        mounted() {
            this.getList();
        }
    }
</script>
